export const screenSize = `
    screenSize {
      screen
    }
`

export const layoutQuery = `
  layouts {
    contentItems {   
      __typename
      ... on LayoutStyle {
        ${screenSize}
        wrap
        columnCount
        itemLayouts {
          contentItems{
            __typename
            ... on ItemSpan {
              colSpan
              rowSpan
            }
          }
        }
      }
    }
  }
`

export const customizations = `
customizations {
  contentItems{
    contentType
    __typename
    ... on HeaderSettings {
      ${screenSize}
      darkMode
      subtitle
      description
      hidden
      darkMode
      alignment
      navigation {
        text
        url
      }
    }
    __typename
    ... on BackgroundImageStyle{
      ${screenSize}
      image {
        paths
      }
      size
      flip
      repeat
      positionX
      positionY
      offsetX
      offsetY
    }
    __typename
    ... on BackgroundColorStyle {
      ${screenSize}
      color
      opacity
    }
    __typename
    ... on PaddingStyle {
      ${screenSize}
      top
      bottom
      start
      end
    }
    __typename
    ... on MarginStyle {
      ${screenSize}
      top
      bottom
      start
      end
    }
    __typename
    ... on SizingStyle {
      ${screenSize}
      widthMode
      heightMode
      customHight
    }
    __typename
    ... on AlignmentStyle {
      ${screenSize}
      verticalAlignment
      horizontalAlignment
    }
  }
}
`